import CampaignExternalReport from './CampaignExternalReport';

import MediaTargets from './MediaTargets.graphql';

export const CampaignDomoIFrameMediaTargets = MediaTargets;
export { CampaignExternalReport };
